// Get the API URL from environment variables, fallback to window.location.origin if not set
export const getApiBaseUrl = () => {
  // For production, use the VITE_API_TARGET environment variable
  const apiTarget = import.meta.env.VITE_API_TARGET;
  if (apiTarget) {
    // Remove trailing slash if present
    return apiTarget.replace(/\/$/, '');
  }
  
  // Fallback to current origin (for development)
  return window.location.origin;
};

// Helper to construct API URLs
export const getApiUrl = (path: string) => {
  const baseUrl = getApiBaseUrl();
  // Ensure path starts with /api/
  const apiPath = path.startsWith('/api/') ? path : `/api/${path}`;
  return `${baseUrl}${apiPath}`;
}; 